import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { axiosClient } from '../../../../library/Service/axiosClient';

interface CommunicationLog {
    id: number;
    bas_id: number;
    counsellor_id?: any;
    email_to: string;
    email_cc: string;
    email_subject: string;
    email_body: string;
    attachments?: string;
    counselling_stage: number;
    sd_status: string;
    send_on: string;
    delivered_on: string | null;
    added_on: string;
    modified_on: string | null;
    counsellor_first_name?: string | null;
    counsellor_last_name?: string | null;
  }
  

function CommunicationLogs() {
    const { id, pageName } = useParams();
    const [usercommunicationlog, setUserCommunicationLog] = useState<CommunicationLog[]>([]);


    useEffect(() => {
            if (!id) return;
        
            const fetchPreferenceData = async () => {
                try {
                    const response = await axiosClient().get(
                        `${process.env.REACT_APP_BAS_API}/counsellorsession/communication_logs/${id}`
                    );
    
                    const result = response.data?.data;
    
                    console.log(response.data, 'data at 20')
    
                    setUserCommunicationLog(response.data?.data || []);
    
                } catch (error) {
                    console.error("Error fetching preference data:", error);
                }
            };
    
            fetchPreferenceData();
        }, [id]);

  return (
    <>
    <div>
            <div className="counselling-lists">
                <div className="tab-white-block mb-2 p-0 overflow-hidden border">
                    {/* {canEditProfile(model.id, sessionState) && (
                        <a className="pencil-edit" role="button" onClick={() => navigate(`/alumni/${id}/profile-picture`)}></a>
                    )} */}
                    <div className="d-flex flex-wrap flex-column flex-md-row">
                                        <div className="nav flex-row flex-md-column nav-pills custom-sub-tab ps-3 py-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                            <Link className="nav-link" to={`/alumni/${id}/profile/counselling`}>Psychometric Tests </Link>
                                            <Link className="nav-link" to={`/alumni/${id}/profile/sessions`}>Sessions</Link>
                                            <Link className="nav-link" to={`/alumni/${id}/profile/counselling-logs`}>Counselling Logs</Link>
                                            <Link className="nav-link active" to={`/alumni/${id}/profile/communication-logs`} >Communication Logs</Link>
                                            <Link className="nav-link" to={`/alumni/${id}/profile/counsellor-notes`} >Counsellor Notes</Link>   
                                            </div>
                                        <div className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 width-cal-191" id="v-pills-tabContent">
                                          
                                            <div className="tab-pane fade active show" id="v-pills-communication-logs" role="tabpanel" aria-labelledby="v-pills-communication-logs-tab">
                                                    <h3 className='font-20'>Email Communications</h3>
                                                    <div className='row g-4'>
                                                    {usercommunicationlog.length > 0 ? (
                                                        usercommunicationlog.map((log: CommunicationLog, index) => (
                                                            <div className='col-12' key={index}>
                                                            <div className='bg-white radius-6 p-3 p-sm-4 p-mb-4'>
                                                                <ul className='message_counselling_wrap'>
                                                                <li>
                                                                    <p className='font-16 font-500 mb-1'>
                                                                    Subject : {log.email_subject || 'No Subject'}
                                                                    </p>
                                                                    <span className='font-14 font-400'>
                                                                    Session : {log.counselling_stage ? `CS${log.counselling_stage}` : 'N/A'}
                                                                    </span><br />
                                                                    <span className='font-14 font-400'>
                                                                    Added on {log.added_on ? new Date(log.added_on).toLocaleString() : 'N/A'}
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <div className='row'>
                                                                    <div className='col-md-5'>
                                                                        <span className='font-16 font-500'>Send Date :</span> {log.send_on ? new Date(log.send_on).toLocaleString() : 'N/A'}
                                                                    </div>
                                                                    <div className='col-md-5'>
                                                                        <span className='font-16 font-500'>Sent To :</span> {log.email_to || 'N/A'}
                                                                    </div>
                                                                    </div>
                                                                </li>
                                                                <li className='pt-4'>
                                                                    <div className='row g-3'>
                                                                    <div className='col-md-auto'>
                                                                        <div className='message_counselling_user'>
                                                                        <h6>Counsellor</h6>
                                                                        <div className='counselling_user'>
                                                                            <i className='icon-user-invert'></i>
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md'>
                                                                        <div className='message_counselling bg-gray-f2 radius-6 p-3 p-sm-4 p-mb-4'>
                                                                        <div
                                                                            dangerouslySetInnerHTML={{ __html: log.email_body }}
                                                                        />
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                                </li>
                                                                </ul>
                                                            </div>
                                                            </div>
                                                        ))
                                                        ) : (
                                                        <div className="col-12">
                                                            <div className="bg-white radius-6 p-3 p-sm-4 p-mb-4">
                                                            <p className="text-muted">No communication logs found.</p>
                                                            </div>
                                                        </div>
                                                        )}

                                                  
                                                    </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                </div>
                

                

            </div>
        </div>
       
        
    </>
  )
}

export default CommunicationLogs;